import React from "react";
import { defineMessages, injectIntl } from "react-intl";
import SettingHome from "./setting-home.jsx";
import SavedMessage from "./saved-messages.jsx";
import HideTopic from "./hide-conversation.jsx";
import Language from "./language.jsx";
import { Tinode } from "../../../tinode/tinode.js";

const messages = defineMessages({
	log_out: {
		id: 'button_logout',
		defaultMessage: 'Log out',
		description: 'Title for log out warning'
	},
	log_out_warning: {
		id: 'dialog_log_out_warning',
		defaultMessage: 'Important: by logging out you will delete all your message history on Webchat. Do you still want to log out?',
		description: 'Warning message when loging out'
	},
	button_logout: {
		id: 'button_logout',
		defaultMessage: "Logout",
		description: "Button [Logout]",
	}
});

class Setting extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			type: Tinode.DIALOG_SETTING_TYPE.HOME,
		}

		this.getSettingView = this.getSettingView.bind(this);
		this.handleLogout = this.handleLogout.bind(this);
		this.handleSetViewSetting = this.handleSetViewSetting.bind(this);
	}

	handleLogout() {
		const { formatMessage } = this.props.intl;
		this.props.onShowAlert(
			formatMessage(messages.log_out), // title
			formatMessage(messages.log_out_warning), // content
			(_ => { this.props.onLogout(); }), // onConfirm
			formatMessage(messages.button_logout), // "OK"
			true, // Show Reject button
			null  // "Cancel"
		);
	}

	handleSetViewSetting(type) {
		this.setState({
			type: type
		})
	}

	getSettingView() {
		let element = null;
		switch (this.state.type) {
			case Tinode.DIALOG_SETTING_TYPE.HOME:
				element = <SettingHome
					onClose={this.props.onClose}
					handleLogout={this.handleLogout}
					handleSetViewSetting={this.handleSetViewSetting}
					onShowAlert={this.props.onShowAlert}
					onShowDialog={this.props.onShowDialog}
					onSearchContacts={this.props.onSearchContacts}
				/>
				break;
			case Tinode.DIALOG_SETTING_TYPE.SAVED_MESSAGE:
				element = <SavedMessage
					tinode={this.props.tinode}
					onShowAlert={this.props.onShowAlert}
					onClose={this.props.onClose}
					handleShowSettingHome={(_ => this.handleSetViewSetting(Tinode.DIALOG_SETTING_TYPE.HOME))}
				/>
				break;
			case Tinode.DIALOG_SETTING_TYPE.HIDE_TOPIC:
				element = <HideTopic
					tinode={this.props.tinode}
					onShowAlert={this.props.onShowAlert}
					onShowDialog={this.props.onShowDialog}
					onClose={this.props.onClose}
					handleShowSettingHome={(_ => this.handleSetViewSetting(Tinode.DIALOG_SETTING_TYPE.HOME))}
				/>
				break;
			case Tinode.DIALOG_SETTING_TYPE.LANGUAGE:
				element = <Language
					onClose={this.props.onClose}
					handleShowSettingHome={(_ => this.handleSetViewSetting(Tinode.DIALOG_SETTING_TYPE.HOME))}
				/>
				break;
			default:
				break;
		}
		return element;
	}

	render() {
		return (
			<div className="setting">
				{this.getSettingView()}
			</div>
		)
	}
}

export default injectIntl(Setting)